import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = ({ style }) => (
  <path
    style={style}
    d="M47.92,24.59c-0.3,11.74-9.04,21.38-20.38,23.07L9.34,28.71l28.78-14.68L47.92,24.59z"
  />
);

const LeiaAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    defaultBackgroundColor={avatarDefaultBackgroundColors.leia}
    renderShadow={renderShadow}
    {...props}
  >
    <>
      <g>
        <path
          style={{ fill: '#84533E' }}
          d="M32.09,13.71c1.65-1.53,4.48-1.33,6.02,0.31s1.7,4.43,0.46,6.33c1.38,0.43,2.06,2.37,1.26,3.61
		c1.12,0.75,1.3,2.48,0.67,3.69s-1.84,1.99-3.08,2.5c-0.28,0.12-0.57,0.23-0.79,0.44c-0.27,0.27-0.38,0.66-0.59,0.97
		c-0.61,0.93-1.85,1.1-2.93,1.17c-0.75,0.05-1.59,0.05-2.14-0.47c-0.29-0.28-0.46-0.67-0.6-1.05c-2.1-5.54-1.56-12.06,1.4-17.16"
        />
        <path
          style={{ fill: '#724839' }}
          d="M32.25,13.87c1.66-1.43,4.33-1.25,5.79,0.41c1.44,1.64,1.44,4.15,0.34,5.96c-0.08,0.13,0,0.28,0.13,0.33
			c1.29,0.49,1.79,2.1,1.12,3.28c-0.07,0.12-0.02,0.23,0.08,0.31c1.22,0.93,1.12,2.73,0.29,3.88c-0.43,0.6-1.02,1.05-1.65,1.42
			c-0.52,0.3-1.12,0.45-1.62,0.78c-0.48,0.32-0.57,0.77-0.89,1.22c-0.42,0.59-1.09,0.83-1.77,0.96c-0.64,0.11-1.43,0.2-2.07,0.07
			c-1.14-0.23-1.41-1.24-1.72-2.2c-1.71-5.32-1.08-11.26,1.69-16.11c0.14-0.25-0.24-0.48-0.39-0.23c-2.67,4.67-3.41,10.36-2,15.56
			c0.27,1,0.55,2.46,1.45,3.1c0.8,0.56,1.97,0.41,2.87,0.29c0.9-0.12,1.8-0.42,2.33-1.21c0.2-0.29,0.3-0.67,0.56-0.93
			c0.25-0.25,0.8-0.42,1.14-0.58c0.54-0.25,1.06-0.56,1.53-0.94c1.64-1.33,2.39-4.02,0.48-5.47c0.03,0.1,0.05,0.21,0.08,0.31
			c0.82-1.44,0.17-3.35-1.39-3.94c0.04,0.11,0.09,0.22,0.13,0.33c1.25-2.05,1.17-4.94-0.59-6.69c-1.68-1.67-4.47-1.76-6.25-0.22
			C31.71,13.74,32.03,14.06,32.25,13.87L32.25,13.87z"
        />
        <path
          style={{ fill: '#84533E' }}
          d="M15.88,14.57c-0.6-1.04-1.66-1.76-2.79-1.88c-1.13-0.12-2.3,0.36-3.07,1.25c-0.72,0.83-1.08,1.95-1.22,3.07
		c-0.13,1.12,0.02,2.42,0.87,3.07c-0.77,0.93-1.38,2.03-1.78,3.2c-0.27,0.79-0.44,1.63-0.34,2.46c0.14,1.21,0.86,2.28,1.79,2.96
		c0.93,0.68,2.05,1.01,3.16,1.13c0.29,1.05,0.7,2.19,1.6,2.69c0.41,0.22,0.88,0.28,1.34,0.26c2.21-0.1,4.09-2.04,4.84-4.29
		s0.56-4.75,0.1-7.09c-0.3-1.53-0.75-3.11-1.76-4.23c-0.91-1.02-2.27-1.67-2.76-2.99"
        />
        <path
          style={{ fill: '#724839' }}
          d="M16.08,14.46c-1.32-2.1-4.13-2.72-5.99-0.91c-1.54,1.5-2.37,5.09-0.57,6.7c0-0.11,0-0.21,0-0.32
			c-1.63,2.03-3.09,5.14-1.56,7.61c0.68,1.1,1.78,1.83,3,2.21c0.75,0.23,1.28,0.07,1.56,0.87c0.19,0.54,0.42,1.09,0.8,1.53
			c1.74,2.02,4.77,0.25,6.03-1.4c1.8-2.37,1.87-5.52,1.44-8.34c-0.25-1.65-0.6-3.43-1.57-4.84c-0.9-1.31-2.52-1.99-3.15-3.5
			c-0.11-0.27-0.5-0.04-0.39,0.23c0.7,1.66,2.53,2.37,3.41,3.91c1.14,1.99,1.49,4.7,1.48,6.95c-0.01,2.23-0.61,4.58-2.31,6.13
			c-0.76,0.69-1.76,1.25-2.81,1.27c-1.73,0.03-2.31-1.36-2.72-2.78c-0.03-0.11-0.12-0.15-0.22-0.17c-2.05-0.26-4.14-1.31-4.66-3.48
			c-0.48-2.05,0.74-4.34,1.98-5.89c0.07-0.09,0.1-0.23,0-0.32c-1.54-1.37-0.85-4.45,0.35-5.83c1.61-1.86,4.27-1.39,5.51,0.58
			C15.84,14.93,16.23,14.7,16.08,14.46L16.08,14.46z"
        />
        <path
          style={{ fill: '#F4C898' }}
          d="M33.11,18.44l-1.14,13.64c-0.05,1.06-1.05,2.03-1.9,2.6l-3.43,2.98c-1.83,1.25-3.24,1.25-5.07,0l-3.43-2.98
	c-0.85-0.58-1.85-1.55-1.9-2.6L15.1,18.43c-0.08-1.55,0.21-3.01,1.49-3.79l4.53-2.76c1.83-1.11,4.08-1.11,5.91-0.01l4.58,2.77
	C32.9,15.42,33.19,16.88,33.11,18.44z"
        />
        <path
          style={{ fill: '#84533E' }}
          d="M15.41,24.86c0.31-1.96,0.62-4.23,2.08-5.71c1.31-1.32,3.24-1.71,5.04-1.66c0.96,0.03,0.96-1.47,0-1.5
			c-2.16-0.06-4.42,0.48-6.01,2.02c-1.74,1.68-2.19,4.17-2.55,6.45c-0.06,0.4,0.1,0.81,0.52,0.92
			C14.84,25.48,15.35,25.26,15.41,24.86L15.41,24.86z"
        />
        <path
          style={{ fill: '#84533E' }}
          d="M32.69,23.53c-0.87-2.41-0.47-3.27-2.29-4.16c-1.7-0.83-3.34-0.09-5.06,0.44c-0.2,0.07-0.88-0.09-0.91-0.35
		c-0.12-1-0.23-4.74-0.27-5.75c-0.01,0.98-0.01,4.7-0.12,5.68c-0.03,0.26-0.7,0.42-0.91,0.36c-1.72-0.51-3.23-1.23-4.92-0.37
		c-1.81,0.92-1.94,1.72-2.78,4.15c-0.56-1.99-1.36-6.28-0.93-8.55c0.33-1.76,2.05-3.93,3.12-4.4c1.33-0.59,4.09-1.31,5.96-0.3
		c0.16,0.09,0.38,0.43,0.38,0.43s0.19-0.47,0.38-0.56c2-0.9,5.01-0.23,6.39,0.48c1.01,0.51,2.28,1.86,2.78,3.47
		C34.22,16.38,33.02,22.64,32.69,23.53z"
        />
        <path
          style={{ fill: '#724839' }}
          d="M32.9,23.47c-0.38-1.09-0.48-2.54-1.24-3.45c-0.96-1.15-2.62-1.4-4.01-1.13c-0.61,0.12-2.61,1.13-3.02,0.46
			c-0.21-0.35-0.09-1.31-0.11-1.71c-0.06-1.31-0.1-2.62-0.15-3.93c-0.01-0.29-0.45-0.29-0.45,0c-0.01,1.26-0.01,2.51-0.04,3.77
			c-0.01,0.43,0.15,1.43-0.07,1.81c-0.39,0.66-2.35-0.3-2.95-0.42c-1.44-0.28-2.88,0.11-3.96,1.11c-0.97,0.89-1.28,2.3-1.69,3.49
			c0.14,0,0.29,0,0.43,0c-0.42-1.52-0.71-3.09-0.89-4.66c-0.19-1.63-0.35-3.42,0.36-4.95c0.69-1.48,1.76-2.83,3.34-3.35
			c1.37-0.46,4.32-1.12,5.32,0.32c0.08,0.12,0.32,0.17,0.39,0c0.38-0.89,1.79-0.89,2.62-0.88c1.06,0.01,2.13,0.21,3.12,0.57
			c1.89,0.69,3.36,2.52,3.57,4.53c0.17,1.66-0.06,3.38-0.3,5.02c-0.17,1.12-0.31,2.32-0.69,3.4c-0.1,0.27,0.34,0.39,0.43,0.12
			c0.49-1.37,0.65-2.93,0.83-4.37c0.22-1.78,0.53-3.88-0.15-5.6c-0.79-1.98-2.37-3.27-4.4-3.79c-1.38-0.36-4.69-0.95-5.42,0.77
			c0.13,0,0.26,0,0.39,0c-0.94-1.35-3.22-1.14-4.63-0.85c-1.82,0.37-3.04,1.13-4.11,2.66c-1.17,1.69-1.37,3.44-1.22,5.44
			c0.15,1.93,0.49,3.87,1,5.74c0.06,0.22,0.36,0.2,0.43,0c0.5-1.46,0.85-2.95,2.26-3.79c1.16-0.69,2.33-0.68,3.6-0.32
			c0.65,0.18,1.41,0.63,2.1,0.45c0.99-0.26,0.72-1.54,0.73-2.34c0.03-1.29,0.03-2.59,0.04-3.88c-0.15,0-0.3,0-0.45,0
			c0.05,1.27,0.09,2.54,0.14,3.82c0.04,0.81-0.23,2.22,0.78,2.48c0.7,0.18,1.47-0.29,2.13-0.48c1.23-0.35,2.46-0.45,3.61,0.21
			c1.36,0.78,1.41,2.51,1.88,3.86C32.57,23.86,33,23.74,32.9,23.47z"
        />
        <path
          style={{
            fill: 'none',
            stroke: '#282828',
            strokeWidth: 0.4992,
            strokeMiterlimit: 10,
          }}
          d="M30.05,27.31"
        />
        <path
          style={{
            fill: 'none',
            stroke: '#282828',
            strokeWidth: 0.4992,
            strokeMiterlimit: 10,
          }}
          d="M26.23,28.64"
        />
        <path
          style={{ fill: '#DD7A66' }}
          d="M21.71,34.54c-0.16,0.26,0.2,0.54,0.71,0.68c0.51,0.14,1.13,0.16,1.72,0.16c0.56,0,1.14-0.03,1.63-0.15
		s0.87-0.36,0.82-0.62c-0.01-0.03-0.02-0.06-0.06-0.08c-0.06-0.03-0.16-0.04-0.25-0.05c-1.21-0.1-2.44-0.14-3.66-0.13
		c-0.28,0-0.58,0.01-0.82,0.08"
        />
        <path
          style={{ fill: '#DD7A66' }}
          d="M21.59,34.46c-0.31,0.61,0.71,0.9,1.12,0.97c0.81,0.14,1.69,0.14,2.5,0.04c0.37-0.04,0.74-0.11,1.08-0.27
			c0.21-0.1,0.47-0.29,0.47-0.55c0-0.32-0.37-0.32-0.61-0.34c-0.46-0.04-0.93-0.06-1.39-0.08c-0.52-0.02-1.03-0.03-1.55-0.04
			c-0.48,0-0.98-0.03-1.44,0.08c-0.19,0.05-0.11,0.34,0.08,0.29c0.41-0.1,0.85-0.07,1.27-0.07c0.42,0,0.84,0.01,1.26,0.02
			c0.45,0.01,0.9,0.04,1.35,0.07c0.2,0.01,0.49-0.02,0.67,0.05c0.07,0.03,0.07-0.01,0.05,0.07c-0.01,0.07-0.13,0.13-0.18,0.16
			c-0.33,0.21-0.76,0.27-1.14,0.31c-0.4,0.04-0.79,0.05-1.19,0.04c-0.41,0-0.82-0.02-1.22-0.1c-0.16-0.03-1-0.23-0.86-0.51
			C21.93,34.44,21.67,34.29,21.59,34.46L21.59,34.46z"
        />
        <path
          style={{ fill: '#B75D4E' }}
          d="M21.68,34.5c0.4-0.59,1.39-0.9,2.41-0.91s2.03,0.3,2.44,0.88c0.02,0.02,0.03,0.05,0.01,0.07
		c-0.02,0.02-0.05,0.02-0.08,0.02c-0.71,0.04-1.36-0.18-2.24-0.18c-0.89,0-2.13,0.14-2.56,0.21L21.68,34.5z"
        />
        <path
          style={{ fill: '#B75D4E' }}
          d="M21.81,34.57c0.49-0.69,1.55-0.84,2.33-0.83c0.45,0,0.9,0.06,1.33,0.2c0.19,0.06,0.37,0.14,0.54,0.25
			c0.09,0.05,0.17,0.12,0.25,0.19c0.03,0.03,0.06,0.06,0.08,0.09c0.02,0.02,0.03,0.03,0.04,0.05c0.03,0.05,0.03,0.04,0.02-0.01
			c0.03-0.03,0.07-0.07,0.1-0.1c-0.17,0.07-0.43,0.02-0.61,0c-0.22-0.02-0.43-0.05-0.65-0.08c-0.47-0.06-0.94-0.09-1.42-0.07
			c-0.74,0.03-1.48,0.1-2.21,0.2c0.06,0.06,0.12,0.12,0.18,0.18c0.01-0.03,0.02-0.06,0.03-0.1c0.06-0.19-0.23-0.26-0.29-0.08
			c-0.01,0.03-0.02,0.06-0.03,0.1c-0.04,0.12,0.08,0.2,0.18,0.18c0.67-0.1,1.34-0.16,2.02-0.19c0.43-0.02,0.86-0.01,1.29,0.04
			c0.4,0.05,0.79,0.12,1.19,0.13c0.19,0,0.65,0,0.47-0.32c-0.14-0.26-0.46-0.45-0.71-0.58c-0.7-0.34-1.54-0.43-2.31-0.36
			c-0.76,0.07-1.62,0.31-2.09,0.96C21.44,34.58,21.69,34.73,21.81,34.57z"
        />
      </g>
    </>
  </AvatarArtwork>
);

export default LeiaAvatarArtwork;
